import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { LIGHT_SOY, SOY } from 'reservations/brand/constants';

const LoadingSpinner = ({ message }: { message?: string }) => (
  <Grid
    container
    direction="column"
    data-testid="page-loading-spinner"
    alignContent="center"
    alignItems="center"
    gap="16px"
  >
    <CircularProgress sx={{ color: LIGHT_SOY }} />
    {!!message && (
      <Typography component="p" sx={{ color: SOY, fontWeight: 500 }}>
        {message}
      </Typography>
    )}
  </Grid>
);

export default LoadingSpinner;
